export default "__VITE_ASSET__CKhtWNhz__"